import { Directive, ElementRef, Input, OnChanges } from '@angular/core';

@Directive({
  selector: '[MathJax]',
})
export class MathJaxDirective implements OnChanges {
  @Input('MathJax') texExpression!: string;
  mathJax!: {
    hub: {
      queue: (param: Record<string, unknown>[]) => void;
    };
  };

  constructor(private el: ElementRef) {}

  ngOnChanges(): void {
    this.el.nativeElement.innerHTML = this.texExpression;
    if (this.mathJax?.hub?.queue) {
      this.mathJax.hub.queue([
        'Typeset',
        this.mathJax.hub,
        this.el.nativeElement,
      ]);
    }
  }
}
